import { render, staticRenderFns } from "./UpfrontContribution.vue?vue&type=template&id=07c710b8&scoped=true"
import script from "./UpfrontContribution.vue?vue&type=script&lang=ts"
export * from "./UpfrontContribution.vue?vue&type=script&lang=ts"
import style0 from "./UpfrontContribution.vue?vue&type=style&index=0&id=07c710b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c710b8",
  null
  
)

export default component.exports